import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client'
import * as serviceWorker from './serviceWorker';
import App from './App';
import { WorkerConfig } from "./components/NewVersion";
import ErrorBoundary from './components/Error/ErrorHandler'
import { RecoilRoot } from 'recoil'
import { LoadingView } from "./components/Loading";

//all others service works should be inside this component
//generateThemeVariables();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <RecoilRoot>
        <ErrorBoundary>
            <Suspense fallback={<LoadingView containerHeight='100vh' imgHeight='40px' />}>
                <App />
            </Suspense>
        </ErrorBoundary>
    </RecoilRoot>
);

serviceWorker.register(WorkerConfig);